// PrescriptionPreview.js
import React, { useRef } from 'react';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import Button from '../../shared/components/FormElements/Button';
import './PrescriptionPreview.css';
import { BACKEND_URL } from '../../shared/util/backend-url';

const PrescriptionPreview = ({ prescriptionData, fullData }) => {
  const previewRef = useRef();

  const handleDownloadPDF = async () => {
  const watermarkImg = previewRef.current.querySelector('.watermark-img');

  if (watermarkImg && !watermarkImg.complete) {
    await new Promise(resolve => {
      watermarkImg.onload = resolve;
      watermarkImg.onerror = resolve;
    });
  }

  const canvas = await html2canvas(previewRef.current, {
    useCORS: true, // VERY IMPORTANT for external images
    allowTaint: false,
    scale: 2 // improves resolution
  });

  const imgData = canvas.toDataURL('image/png');
  const pdf = new jsPDF('p', 'mm', 'a4');
  const pdfWidth = pdf.internal.pageSize.getWidth();
  const pdfHeight = (canvas.height * pdfWidth) / canvas.width;
  pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);
  pdf.save(`Prescription_${prescriptionData.patientName}.pdf`);
};

  const handlePharmacy = async () => {
  try {
    const response = await fetch(`${BACKEND_URL}/api/pharmacy/send`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        doctorId: fullData.doctor._id,
        pharmacyId: fullData.doctor.associatedPharmacy,
        patientId: fullData.patient._id,
        patientName: prescriptionData.patientName,
        age: prescriptionData.age,
        sex: prescriptionData.sex,
        diagnosis: prescriptionData.diagnosis,
        vitals: prescriptionData.vitals,
        medications: prescriptionData.medications,
        remarks: prescriptionData.remarks
      })
    });

    const data = await response.json();
    if (response.ok) {
      alert('Prescription sent to pharmacy!');
    } else {
      alert(data.message || 'Failed to send prescription');
    }
  } catch (err) {
    console.error('Error sending to pharmacy:', err);
    alert('Error sending prescription.');
  }
};

 const handlePrint = () => {
      const printWindow = window.open('', '_blank');
      printWindow.document.write(`
        <html>
          <head>
            <title>Print Prescription</title>
            <style>
              body {
                font-family: Arial, sans-serif;
                position: relative;
              }
              .watermark-img {
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                opacity: 0.08;
                width: 300px;
                height: auto;
                pointer-events: none;
                z-index: 0;
              }
              .prescription-preview > *:not(.watermark-img) {
                position: relative;
                z-index: 1;
              }
              .signature-img {
                width: 120px;
                float: right;
              }
              .highlight-diagnosis {
                background-color: yellow;
                padding: 2px 4px;
                border-radius: 4px;
              }
            </style>
          </head>
          <body>
            ${previewRef.current.innerHTML}
          </body>
        </html>
      `);
      printWindow.document.close();
      printWindow.focus();
      printWindow.print();
    };

  const handleSendToWhatsApp = () => {
    const text = `Doctor: ${prescriptionData.doctorName}\nSpecialist: ${prescriptionData.specialization}\n\nPatient: ${prescriptionData.patientName} (${prescriptionData.age}, ${prescriptionData.sex})\nDiagnosis: ${prescriptionData.diagnosis}\n\nMedication: ${prescriptionData.medication} (${prescriptionData.dosage}) for ${prescriptionData.duration} days`;
    const phone = ''; // Insert default number if needed
    window.open(`https://wa.me/${phone}?text=${encodeURIComponent(text)}`);
  };

  return (
    <div className="prescription-wrapper">
      <div ref={previewRef} className="prescription-preview">
        <img
          src="https://gimgs2.nohat.cc/thumb/f/350/caduceus-medical-symbol-clipart-doctor-symbol--m2i8K9d3G6i8N4K9.jpg"
          alt="Watermark"
          className="watermark-img"
        />
        <h2>{prescriptionData.doctorName}</h2>
        <h4>{prescriptionData.specialization}</h4>
        <p>{prescriptionData.location}</p>
        <p><strong>Phone:</strong> {prescriptionData.phone}</p>
        <hr />
        <p><strong>Name:</strong> {prescriptionData.patientName} <strong>Age:</strong> {prescriptionData.age} <strong>Sex:</strong> {prescriptionData.sex}</p>
        <p><strong>Date:</strong> {prescriptionData.date}</p>
        <p><strong>Diagnosis:</strong> <span className="highlight-diagnosis">{prescriptionData.diagnosis}</span></p>
        <p><strong>Vitals:</strong> {prescriptionData.vitals}</p>
        <img 
         src={'https://icon2.cleanpng.com/20180203/gpq/avir50k72.webp'}
         alt="icon"
         className='iconRX'
        />
        {prescriptionData.medications.map((med, i) => (
          <div key={i} className="medication-block">
            <p><strong>{med.name}</strong> ({med.dose})</p>
            <p>{med.frequency} | {med.duration}</p>
          </div>
        ))}
        <br />
        <p><strong>Remarks:</strong> {prescriptionData.remarks}</p>
        <p className="member-code">{prescriptionData.memberCode}</p>
        <img
          src={`${BACKEND_URL}/${prescriptionData.signature}`}
          alt="Doctor Signature"
          className="signature-img"
        />
      </div>

      <div className="prescription-actions">
        <Button onClick={handleDownloadPDF}>Share as PDF</Button>
        <Button onClick={handlePrint}>Print</Button>
        <Button onClick={handlePharmacy}>Send To Pharmacy</Button>
        <Button onClick={handleSendToWhatsApp}>Send to WhatsApp</Button>
      </div>
    </div>
  );
};

export default PrescriptionPreview;


